module.exports = __webpack_public_path__ + "h5/img/roots1.9bb724b0.jpg";